import ThongTinBenhAn from "./thong-tin-benh-an";
import {BenhAnContextProvider} from "../shared/BenhAnContextProvider";
import {BenhAnTree} from "./tree-benh-an";

type Props = {
	disabled?: boolean;
}

const BenhAnContent = ({ disabled }: Props) => {
	return (
		<BenhAnContextProvider>
			<div className="d-flex spaces h-calc-45">
				<div className="spaces width-20 bg-white min-w-200">
					<BenhAnTree />
				</div>
				<div className="spaces width-80 bg-light radius-2">
					<ThongTinBenhAn disabled={disabled} />
				</div>
			</div>
		</BenhAnContextProvider>
	);
};

export default BenhAnContent;
